// extracted by mini-css-extract-plugin
export default {"language-selector":"language-selector_language-selector__21YWq","language-selector__button_active":"language-selector_language-selector__button_active__3aSlv"};